import { combineReducers } from 'redux';
import companyRegulation from '../screens/CompanyRegulation/reducers/';
import regulationManagement from '../screens/RegulationManagement/reducers/';
export default combineReducers({
  companyRegulation,
  regulationManagement,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyRules/reducers/index.js
 **/